import { IonSpinner } from "@ionic/react";
import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const WrapperContainer = styled.div`
	width: 100%;
	display: inline-block;
`;

const LoadingContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const FallbackError = styled.div`
	color: red;
	background-color: #ffe5e5;
	padding: 20px;
	border-radius: 5px;
	text-align: center;
	font-size: 18px;
	animation: ${fadeIn} 0.3s ease-in-out;
`;

const FadeContainer = styled.div<any>`
	animation: ${({ isLoading }) => (isLoading ? fadeIn : fadeOut)} 0.3s ease-in-out;
`;

const AsyncContentWrapper = ({ isLoading, error, errorComponent: ErrorComponent, children }: any) => {
	const [shouldRender, setShouldRender] = useState(isLoading); // Manages render state

	useEffect(() => {
		if (!isLoading && !error) {
			const timeout = setTimeout(() => setShouldRender(false), 300); // Matches animation time
			return () => clearTimeout(timeout); // Cleanup timeout on unmount
		} else {
			setShouldRender(true);
		}
	}, [isLoading, error]);

	if (error && !isLoading) {
		return (
			<WrapperContainer>
				{ErrorComponent ? (
					<ErrorComponent error={error} />
				) : (
					<FallbackError>
						<h2>Oops! Something went wrong.</h2>
						<p>{error}</p>
					</FallbackError>
				)}
			</WrapperContainer>
		);
	}

	if (shouldRender && isLoading) {
		return (
			<LoadingContainer>
				 <IonSpinner name='dots' color={"#F2F2F2"} />
			</LoadingContainer>
		);
	}

	return (
		<WrapperContainer>
			<FadeContainer isLoading={!isLoading}>{children}</FadeContainer>
		</WrapperContainer>
	);
};

export default AsyncContentWrapper;
